import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from './locales/fr.json';
import en from './locales/en.json';

const SUPPORTED = ['fr', 'en'];

// Try to detect lang from current URL path (/fr/... or /en/...). Falls back to fr.
const detectInitialLang = () => {
  if (typeof window === 'undefined') return 'fr';
  const seg = window.location.pathname.split('/').filter(Boolean)[0];
  if (SUPPORTED.includes(seg)) return seg;
  return 'fr';
};

i18n.use(initReactI18next).init({
  resources: {
    fr: { translation: fr },
    en: { translation: en },
  },
  lng: detectInitialLang(),
  fallbackLng: 'fr',
  supportedLngs: SUPPORTED,
  returnObjects: true,
  interpolation: { escapeValue: false },
});

export default i18n;
export { SUPPORTED };

/**
 * pickLocalized(item, field, lang)
 * Returns item[`${field}_en`] when lang === 'en' and the translation exists,
 * otherwise falls back to item[field].
 */
export const pickLocalized = (item, field, lang) => {
  if (!item) return '';
  if (lang === 'en') {
    const v = item[`${field}_en`];
    if (Array.isArray(v) ? v.length > 0 : (v && String(v).trim())) return v;
  }
  return item[field];
};
